import { ModelBase } from 'store/model-base';

export class DeviceEsimTransfer extends ModelBase {
    public static storeName: string = 'deviceEsimTransfer';

    public orderId: string;
    public orderKey: string;
}
